import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";

export default function ListTemplate(props) {
  const [templates, setTemplates] = useState(props.templates);
  const current_user = props.current_user
  const params_id = props.user_id
  const useTemplate = async (placeholder) => {
    const data = {
        title: placeholder.title,
        content: placeholder.content,
        isFromTemplate: "true"
    }
    const encodedTemplate = encodeURIComponent(JSON.stringify(data))
    if (props.user == 'true') {
     window.location.href = `/users/${params_id}/posts/new?template=${encodedTemplate}`
    }
    if (props.project == 'true') {
      window.location.href = `/projects/${params_id}/posts/new?template=${encodedTemplate}`
    }
  }



  return (
    <React.Fragment>
        <div className="card">
        <div>
          <div className="list-group list-group-flush">
            {templates.map((template, index) => (
              <div key={template.id} className="list-group-item">
                <div className='list-group-item-body'>
                  <div className='list-group-item-body-main'>
                    <span>{template.title}</span>
                  </div>
                </div>
                <div className='list-group-item-actions'>
                {(props.project || props.user) &&
                  <a href="#" className="btn btn-sm btn-outline-primary" onClick={() => useTemplate(template)}>Use Template</a>
                }
                  {/* Hiding button unless assesed through manager profile or settings */}
                {!props.project && !props.user &&
                <div>
                    <a href={`/templates/view/${template.id}`} className="btn btn-sm btn-outline-primary">View Template</a>
                    <a href={`/templates/edit/${template.id}`} className="btn btn-sm btn-primary ml-2"><i className="fa fa-pencil"></i> Edit Template</a>
                </div>
                }
                </div>
              </div>
            ))}
          </div>
        </div>

        {templates.length == 0 &&
          <div className="card-body">
            Let's get started with your first template :)
          </div>
        }
      </div>
    </React.Fragment>
  );
}

ListTemplate.propTypes = {
  templates: PropTypes.array
};
